import {
  NgpSlider,
  NgpSliderRange,
  NgpSliderThumb,
  NgpSliderTrack,
} from 'ng-primitives/slider';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  ChangeDetectionStrategy,
  Component,
  effect,
  input,
  output,
  signal,
} from '@angular/core';

@Component({
  selector: 'app-chat-sound',
  imports: [
    NgpSlider,
    NgpSliderRange,
    NgpSliderThumb,
    NgpSliderTrack,
    SvgIconComponent,
  ],
  standalone: true,
  templateUrl: './chat-sound.component.html',
  styleUrl: './chat-sound.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatSoundComponent {
  volume = input.required<number>();
  changeVolume = output<number>();

  value = signal<number>(1);

  constructor() {
    effect(() => {
      this.changeVolume.emit(this.value());
    });
  }

  ngOnInit() {
    this.value.set(this.volume());
  }

  toggleSound() {
    const currentValue = this.value();
    this.value.set(currentValue > 0 ? 0 : 100);
  }
}
